import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pickVariant: {
    id: 'pd.variant.drawer.pickVariant',
    defaultMessage: 'Zvolte si odstín',
  },
});
